module.exports = __webpack_public_path__ + "static/cover-876873ba3d0241b9f5004c210379dd24.webp";